import React from 'react';
import './answer.css';
import { Message, AgentType, WorkflowNode } from './types';
import { ChatWindow } from './components/chat-window';

export interface ChatBubbleProps {
  isOpen: boolean;
  messages: Message[];
  isLoading: boolean;
  selectedAgent?: AgentType;
  title?: string;
  subtitle?: string;
  placeholder?: string;
  currentSessionId?: string;
  availableChats?: Array<{
    _id: string;
    title?: string;
    sessionId: string;
    messages: any[];
    createdAt: string;
    updatedAt: string;
  }>;
  isSwitchingChat?: boolean;
  deletingChatId?: string | null;
  streamingNodes?: WorkflowNode[];
  onClose: () => void;
  onSendMessage: (message: string) => void;
  onSelectAgent: (agent: AgentType) => void;
  onRestart: () => void;
  onSwitchChat?: (sessionId: string) => void;
  onDeleteChat?: (sessionId: string) => void;
  onNewChat?: () => void;
  additionalMetadata?: Record<string, any>;
}

export function ChatBubble({
  isOpen,
  messages,
  isLoading,
  selectedAgent,
  title,
  subtitle,
  placeholder,
  currentSessionId,
  availableChats,
  isSwitchingChat,
  deletingChatId,
  streamingNodes,
  onClose,
  onSendMessage,
  onSelectAgent,
  onRestart,
  onSwitchChat,
  onDeleteChat,
  onNewChat,
  additionalMetadata,
}: ChatBubbleProps) {
  return (
    <ChatWindow
      isOpen={isOpen}
      messages={messages}
      isLoading={isLoading}
      selectedAgent={selectedAgent ?? null as any}
      title={title}
      subtitle={subtitle}
      placeholder={placeholder}
      currentSessionId={currentSessionId}
      availableChats={availableChats}
      isSwitchingChat={isSwitchingChat}
      deletingChatId={deletingChatId}
      streamingNodes={streamingNodes}
      onClose={onClose}
      onSendMessage={onSendMessage}
      onSelectAgent={onSelectAgent}
      onRestart={onRestart}
      onSwitchChat={onSwitchChat}
      onDeleteChat={onDeleteChat}
      onNewChat={onNewChat}
    />
  );
}
